<template>
  <div class="comparison-report-page">
    <div class="report-header d-flex align-center justify-space-between mb-4">
      <div>
        <h4 class="mb-1">Sistem Karşılaştırma Raporu</h4>
        <span class="text-caption text-medium-emphasis">Eski sistem (file_search) vs. Yeni sistem (MCP + pgvector)</span>
      </div>
      <v-btn
        color="primary"
        variant="outlined"
        size="small"
        prepend-icon="refresh"
        :loading="loading"
        @click="loadReport"
      >
        Yenile
      </v-btn>
    </div>

    <div v-if="loading" class="d-flex justify-center align-center" style="height: 400px">
      <v-progress-circular indeterminate color="primary" size="48" />
    </div>

    <div v-else-if="error" class="d-flex justify-center align-center" style="height: 400px">
      <div class="text-center">
        <span class="material-symbols-outlined" style="font-size:48px;color:#ccc">error_outline</span>
        <p class="mt-2 text-medium-emphasis">{{ error }}</p>
        <v-btn color="primary" variant="tonal" @click="loadReport">Tekrar Dene</v-btn>
      </div>
    </div>

    <div v-else class="report-frame-wrapper">
      <iframe
        ref="reportFrame"
        :srcdoc="reportHtml"
        frameborder="0"
        class="report-frame"
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

export default defineComponent({
  name: 'ComparisonReportPage',

  setup() {
    const reportHtml = ref<string>('')
    const loading    = ref(true)
    const error      = ref<string | null>(null)
    const reportFrame = ref<HTMLIFrameElement | null>(null)

    async function loadReport() {
      loading.value = true
      error.value   = null

      try {
        const token = localStorage.getItem('auth_token')
        const res   = await axios.get(`${API_BASE_URL}/admin/comparison-report`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'text',
        })
        reportHtml.value = res.data
      } catch (e: any) {
        error.value = e?.response?.data?.message ?? 'Rapor yüklenirken bir hata oluştu.'
      } finally {
        loading.value = false
      }
    }

    onMounted(loadReport)

    return { reportHtml, loading, error, reportFrame, loadReport }
  },
})
</script>

<style scoped>
.comparison-report-page {
  padding: 24px;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}

.report-frame-wrapper {
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.report-frame {
  width: 100%;
  height: 100%;
  display: block;
  background: #fff;
}
</style>
